import { useQuery } from '@tanstack/react-query';
import { getMembers } from './client';

export function useMembers() {
  const { data } = useQuery({ queryKey: ['members'], queryFn: getMembers, staleTime: 10 * 60_000 });
  const members = data ?? [];
  return {
    members,
    ownerOptions: members.map((m) => ({ value: m.userId, label: m.name ?? m.email })),
  };
}
